import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { attach, createStore, sample } from 'effector'
import { features } from '~/core/flags'
import { register } from '~/core/repository'
import { model as session } from '~/entities/session'
import { exists } from '~/shared/helpers'
import { isGuestSession } from './lib'

// indicates about enabled or disabled guest mode feature
export const $enabled: Store<boolean> = // `false` by default
  features.get('guestModeEnabled', false)

export const guestInFx = attach({
  effect: api.session.guestInFx,
  mapParams: (_?: false) => undefined,
})

// store, indicating, if we logged in as guest
export const $guest: Store<boolean | null> = session.$session.map((session) =>
  exists(session) ? isGuestSession(session) : null
)

// authentication mode - user | guest
export const $mode = createStore<null | 'user' | 'guest'>(null)
  .on(api.session.signInFx.done, () => 'user')
  .on(api.session.guestInFx.done, () => 'guest')
  .on(session.$session, (current, session) =>
    session && typeof session.profileId === 'number'
      ? isGuestSession(session)
        ? 'guest'
        : 'user'
      : current
  )

//
// disable guest mode in case of error WB0065
//

sample({
  clock: api.events.logic.guestModeDisabled,
  fn: () => ({ guestModeEnabled: false }),
  target: [features.set, session.stopGuestReloginTransition],
})

sample({
  clock: api.session.guestInFx.fail,
  target: session.stopGuestReloginTransition,
})

//
// register stores and events
//

register($guest, '$feature/guest')
